import { render, staticRenderFns } from "./UserAddress.vue?vue&type=template&id=a4fc5744&scoped=true"
import script from "./UserAddress.vue?vue&type=script&lang=js"
export * from "./UserAddress.vue?vue&type=script&lang=js"
import style0 from "./UserAddress.vue?vue&type=style&index=0&id=a4fc5744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fc5744",
  null
  
)

export default component.exports